import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/ANA/IDEAL_FASTENERS_RGB_PRIMARY_LOGO_AW.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLine } from './components/QuoteLine';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';
import { TermsAndConditions } from './components/TermsAndConditions';
import { noHyphenation } from './utils/hyphenation';

const SITE_INFORMATION = [
  '3850 E. Miraloma Ave',
  'Anaheim, CA 92806',
  'PH: (714) 630-7840',
  'FX: (714) 630-1101',
];

export function ANAQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo source={logo} />

        <SiteInformation name="Ideal Fasteners" items={SITE_INFORMATION} />

        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation />
      </QuoteDetails>

      {quoteLines.map((line) => {
        return (
          <QuoteLine key={line.id} {...line} showDrawing>
            <PartId {...line.part} showCustomerPartId />

            <PartSpecs specs={line.specs} />
          </QuoteLine>
        );
      })}

      <Specs />

      <EmployeeInformation />

      <View style={styles.row}>
        <View style={[styles.fullRow]}>
          <Text style={[styles.bold, { color: 'red' }]}>
            Please forward your POs to po@idealfasteners.com
          </Text>
          <Text style={[styles.bold]}>
            Follow-Up: Please get in touch with Stephanie -
            srojas@idealfasteners.com
          </Text>
          <Text style={[styles.bold]}>
            Quality: Please get in touch with kelly@idealfasteners.com or
            bao@idealfasteners.com
          </Text>
          <Text style={[styles.bold]}>
            Purchasing: Please get in touch with benji@idealfasteners.com
          </Text>
          <Text style={[styles.bold]} hyphenationCallback={noHyphenation}>
            Sales: Please get in touch with facundo@idealfasteners.com,
            junior@idealfasteners.com, benji@idealfasteners.com and Nancy -
            nperez@idealfasteners.com
          </Text>
        </View>
      </View>

      <View style={[styles.row]}>
        <View style={[styles.sectionHalf]}>
          <Text style={[styles.bold]}>Minimum line item $100.00</Text>

          <Text>NAS/MS - Full certifications included with shipment</Text>
          <Text>
            Non Military - Material and process certifications included with
            shipment
          </Text>
          <Text>
            Priced per quantity released - Stock subject to prior sales
          </Text>
          <Text>ISO9001: 2015 & AS9100D Certified</Text>
          <Text>Nadcap NDT certified</Text>
        </View>

        <View style={[styles.sectionHalf]}>
          <Text style={[styles.bold]}>Cancellation fee may apply</Text>

          <Text>AS9102 FAI $950.00 lot charge</Text>
          <Text>AS9102/NetInspect FAI $1500.00 lot charge</Text>
          <Text>PAP $1500.00 lot charge</Text>
          <Text>Standard dimensional report included on request</Text>
          <Text>Quote valid for 90 days subject to material availability</Text>
        </View>
      </View>

      <View style={styles.row}>
        <View style={[styles.fullRow, { marginBottom: 4 }]}>
          <Text style={[styles.bold, styles.textSmall]}>
            This quotation is made without benefit of reviewing any PO
            directions involving: dimensional or performance specifications,
            process directions, shipping requirements, QC clauses, or any other
            requirement that may additionally impact the cost of producing the
            quoted product. If such direction occurs with your submission of a
            PO, MW Components - Ideal Fasteners reserves the right to increase
            the price of the quoted product to compensate for the added
            activity.
          </Text>
        </View>
      </View>

      <View style={styles.row}>
        <View style={[styles.fullRow, { marginBottom: 4 }]}>
          <Text style={[styles.bold, styles.textSmall]}>
            View Your Order Status & Tracking Online:
          </Text>

          <Text style={[styles.textSmall]}>
            For updates on your order status and tracking information, log in to
            your account on MWComponents.com using the same email address
            associated with your order. Navigate to My Account, then select
            Orders. If you do not already have an account, you can create one.
            Orders associated with the account email address will automatically
            populate.
          </Text>
        </View>
      </View>

      <View
        style={[
          styles.row,
          { borderTopWidth: '1px', borderTopColor: '#000', marginTop: 10 },
        ]}
      >
        <View style={styles.fullRow}>
          <TermsAndConditions style={[styles.textCenter]} />
        </View>
      </View>

      <View style={styles.row}>
        <View style={[styles.fullRow]}>
          <Text style={[styles.bold, styles.textCenter, { fontSize: '20px' }]}>
            All parts are manufactured in the USA
          </Text>
        </View>
      </View>
    </Page>
  );
}
